const defaultSearchFields = [
  { field: "category", placeholder: "Select role" },
  { field: "location", placeholder: "Town or Postcode" },
];

export default defaultSearchFields;
